import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useOkapiKy } from "@folio/stripes/core";
import { Pane, Button } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { useQuery } from "react-query";
import { fetchAgencyPublisherBySourceId } from "../../api/publisherService";
import { PublisherDetail } from "./PublisherDetail";
import { RecekPaneSet } from "../../components/RecekPaneSet";
var PublisherDetailPage = function () {
    var history = useHistory();
    var location = useLocation();
    var ky = useOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var urlParams = new URLSearchParams(location.search);
    var publisherSourceId = urlParams.get("sourceId") || urlParams.get("detail");
    var _a = useQuery(["publisher", publisherSourceId], function () { return fetchAgencyPublisherBySourceId(ky, publisherSourceId); }, {
        enabled: !!publisherSourceId,
    }), publisher = _a.data, isLoading = _a.isLoading, isError = _a.isError, error = _a.error;
    var handleBackToList = function () {
        history.goBack();
    };
    if (!publisherSourceId) {
        return (React.createElement(RecekPaneSet, null,
            React.createElement(Pane, { defaultWidth: "fill", paneTitle: formatMessage({
                    id: "ui-br-agency.publisher.detail.pane.title",
                }) },
                React.createElement("p", null, formatMessage({ id: "ui-br-agency.publisher.id.not.provided" })),
                React.createElement(Button, { buttonStyle: "primary", onClick: handleBackToList },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.button.back" })))));
    }
    if (isLoading) {
        return (React.createElement(RecekPaneSet, null,
            React.createElement(Pane, { defaultWidth: "fill", paneTitle: formatMessage({
                    id: "ui-br-agency.publisher.detail.pane.title",
                }) },
                React.createElement(FormattedMessage, { id: "ui-br-agency.loading" }))));
    }
    if (isError || !publisher) {
        return (React.createElement(RecekPaneSet, null,
            React.createElement(Pane, { defaultWidth: "fill", paneTitle: formatMessage({
                    id: "ui-br-agency.publisher.detail.pane.title",
                }) },
                React.createElement("p", null, (error === null || error === void 0 ? void 0 : error.message) ||
                    formatMessage({ id: "ui-br-agency.publisher.not.found" })),
                React.createElement(Button, { buttonStyle: "primary", onClick: handleBackToList },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.button.back" })))));
    }
    return (React.createElement(RecekPaneSet, null,
        React.createElement(Pane, { defaultWidth: "fill", paneTitle: formatMessage({ id: "ui-br-agency.publisher.detail.pane.title.named" }, { name: publisher.name }), firstMenu: React.createElement(Button, { buttonStyle: "default", onClick: handleBackToList, marginBottom0: true },
                React.createElement(FormattedMessage, { id: "ui-br-agency.button.back" })) },
            React.createElement(PublisherDetail, { publisher: publisher }))));
};
export default PublisherDetailPage;
